import {
  getInstoreTakebackBrand,
  getInstoreTakebackBrandSlugs,
} from "../../core-modules/data";

import Head from "next/head";
import InstoreTakeback from "../../components/InstoreTakeback";
import { BrandProvider } from "../../components/BrandContext";
import { TakebackConfigProvider } from "../../components/TakebackConfigContext";
import AppContextProvider from "../../components/AppContext";
import { ADD_DETAILS, HOW } from "../../core-modules/constants";
import ResetScrollOnStepChange from "../../components/ResetScrollOnStepChange";

function InstoreTakebackPage({ brand, takebackConfig }) {
  return (
    <AppContextProvider
      initialStep={takebackConfig.showSteps ? HOW : ADD_DETAILS}
      storeApprovalRequired={takebackConfig.storeApprovalRequired}
    >
      <BrandProvider brand={brand}>
        <TakebackConfigProvider takebackConfig={takebackConfig}>
          <Head>
            <meta name="robots" content="noindex" />
          </Head>
          <ResetScrollOnStepChange>
            <InstoreTakeback />
          </ResetScrollOnStepChange>
        </TakebackConfigProvider>
      </BrandProvider>
    </AppContextProvider>
  );
}

export default InstoreTakebackPage;

export async function getStaticProps({ params }) {
  const brand = await getInstoreTakebackBrand(params.slug);
  if (!brand) {
    return {
      notFound: true,
    };
  }
  return {
    props: { brand, takebackConfig: brand.takebackConfig },
    revalidate: 60,
  };
}

export async function getStaticPaths() {
  const { brands, errors } = await getInstoreTakebackBrandSlugs();

  const paths = errors.length
    ? []
    : brands.map((brand) => {
        return `/${brand.slug}/instore`;
      });

  return {
    paths,
    fallback: "blocking",
  };
}
